import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaginatedListDataComponent} from './paginated-list-data.component';
import {PaginationModule} from '../pagination/pagination.module';
import {LoadingModule} from '../../../../components/common/loading/loading.module';
import {ContentModule} from '../../../../shared/directives/content.module';
import {ButtonModule} from '../button/button.module';

@NgModule({
    imports: [
        CommonModule,
        PaginationModule,
        LoadingModule,
        ContentModule,
        ButtonModule,
        PaginationModule,
    ],
    exports: [
        PaginatedListDataComponent,
        ContentModule
    ],
    declarations: [
        PaginatedListDataComponent,
    ]
})
export class PaginatedListDataModule {}